/**
 * out_of_stock.js — Amalgamous Out of Stock
 * Affiche le bouton "M'Avertir Si Disponible" sur les variantes en rupture de stock
 * dont les alertes sont activées dans l'admin.
 *
 * Prérequis : app proxy Shopify configuré sur /apps/amalgamous
 */
(function () {
  'use strict';

  // ─── Sélecteurs (adaptés au thème Shopiweb) ───────────────────────────────
  // :not(.secondary-atc-form / .full-set-atc-btn) exclut les formulaires/boutons
  // ATC secondaires embarqués (ex: bloc "Set complet") pour ne jamais cibler
  // le mauvais bouton/formulaire du produit de base affiché sur la page.
  var SEL_FORM        = 'form[action*="/cart/add"]:not(.secondary-atc-form)';
  var SEL_BTN         = '.btn-atc:not(.full-set-atc-btn)';
  var SEL_BTN_TEXT    = '.btn-atc-text';
  var SEL_BUY_BUTTONS = '.product-buy-buttons';

  var WIDGET_ID = 'amalgamous-oos-widget';
  var STYLES_ID = 'amalgamous-oos-styles';

  // ─── Traductions ──────────────────────────────────────────────────────────
  var TRANSLATIONS = {
    fr: {
      notify:   "M'Avertir Si Disponible",
      title:    "M'avertir si disponible",
      desc:     "Entrez votre adresse e-mail pour être notifié(e) dès que ce produit est de nouveau en stock.",
      submit:   "M'avertir",
      success:  "Merci ! Vous serez notifié(e) dès que ce produit est disponible.",
      error:    "Une erreur est survenue. Veuillez réessayer.",
      invalid:  "Adresse email invalide.",
    },
    en: {
      notify:   "Notify Me When Available",
      title:    "Notify me when available",
      desc:     "Enter your email address to be notified when this product is back in stock.",
      submit:   "Notify me",
      success:  "Thank you! You will be notified when this product is available.",
      error:    "An error occurred. Please try again.",
      invalid:  "Invalid email address.",
    },
    es: {
      notify:   "Avisarme Cuando Esté Disponible",
      title:    "Avisarme cuando esté disponible",
      desc:     "Introduce tu dirección de correo electrónico para recibir una notificación cuando este producto vuelva a estar disponible.",
      submit:   "Avisarme",
      success:  "¡Gracias! Se te notificará cuando este producto esté disponible.",
      error:    "Se produjo un error. Por favor, inténtalo de nuevo.",
      invalid:  "Dirección de correo electrónico no válida.",
    },
    de: {
      notify:   "Benachrichtigung bei Verfügbarkeit",
      title:    "Benachrichtigung bei Verfügbarkeit",
      desc:     "Gib deine E-Mail-Adresse ein, um benachrichtigt zu werden, sobald dieses Produkt wieder verfügbar ist.",
      submit:   "Benachrichtigen",
      success:  "Danke! Du wirst benachrichtigt, sobald dieses Produkt verfügbar ist.",
      error:    "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
      invalid:  "Ungültige E-Mail-Adresse.",
    },
    it: {
      notify:   "Avvisami Quando Disponibile",
      title:    "Avvisami quando disponibile",
      desc:     "Inserisci il tuo indirizzo e-mail per essere avvisato quando questo prodotto sarà di nuovo disponibile.",
      submit:   "Avvisami",
      success:  "Grazie! Sarai avvisato quando questo prodotto sarà disponibile.",
      error:    "Si è verificato un errore. Riprova.",
      invalid:  "Indirizzo email non valido.",
    },
    nl: {
      notify:   "Meld Me Aan Voor Beschikbaarheid",
      title:    "Meld me aan voor beschikbaarheid",
      desc:     "Voer je e-mailadres in om een melding te ontvangen zodra dit product weer beschikbaar is.",
      submit:   "Meld me aan",
      success:  "Bedankt! Je ontvangt een melding zodra dit product beschikbaar is.",
      error:    "Er is een fout opgetreden. Probeer het opnieuw.",
      invalid:  "Ongeldig e-mailadres.",
    },
    pt: {
      notify:   "Avisar-me Quando Disponível",
      title:    "Avisar-me quando disponível",
      desc:     "Insira o seu endereço de e-mail para ser notificado quando este produto estiver disponível novamente.",
      submit:   "Avisar-me",
      success:  "Obrigado! Será notificado quando este produto estiver disponível.",
      error:    "Ocorreu um erro. Por favor, tente novamente.",
      invalid:  "Endereço de e-mail inválido.",
    },
    sv: {
      notify:   "Meddela Mig När Tillgänglig",
      title:    "Meddela mig när tillgänglig",
      desc:     "Ange din e-postadress för att få ett meddelande när denna produkt finns i lager igen.",
      submit:   "Meddela mig",
      success:  "Tack! Du kommer att meddelas när denna produkt är tillgänglig.",
      error:    "Ett fel uppstod. Försök igen.",
      invalid:  "Ogiltig e-postadress.",
    },
    da: {
      notify:   "Giv Mig Besked Når Tilgængelig",
      title:    "Giv mig besked når tilgængelig",
      desc:     "Indtast din e-mailadresse for at få besked, når dette produkt er på lager igen.",
      submit:   "Giv mig besked",
      success:  "Tak! Du vil få besked, når dette produkt er tilgængeligt.",
      error:    "Der opstod en fejl. Prøv venligst igen.",
      invalid:  "Ugyldig e-mailadresse.",
    },
    pl: {
      notify:   "Powiadom Mnie O Dostępności",
      title:    "Powiadom mnie o dostępności",
      desc:     "Wpisz swój adres e-mail, aby otrzymać powiadomienie, gdy ten produkt będzie ponownie dostępny.",
      submit:   "Powiadom mnie",
      success:  "Dziękujemy! Otrzymasz powiadomienie, gdy ten produkt będzie dostępny.",
      error:    "Wystąpił błąd. Proszę spróbować ponownie.",
      invalid:  "Nieprawidłowy adres e-mail.",
    },
    ro: {
      notify:   "Anunțați-mă Când Este Disponibil",
      title:    "Anunțați-mă când este disponibil",
      desc:     "Introduceți adresa de e-mail pentru a fi notificat când acest produs va fi din nou în stoc.",
      submit:   "Anunțați-mă",
      success:  "Mulțumim! Veți fi notificat când acest produs va fi disponibil.",
      error:    "A apărut o eroare. Vă rugăm să încercați din nou.",
      invalid:  "Adresă de e-mail invalidă.",
    },
    el: {
      notify:   "Ειδοποίησέ με όταν είναι διαθέσιμο",
      title:    "Ειδοποίησέ με όταν είναι διαθέσιμο",
      desc:     "Εισάγετε τη διεύθυνση email σας για να ειδοποιηθείτε όταν αυτό το προϊόν είναι ξανά διαθέσιμο.",
      submit:   "Ειδοποίησέ με",
      success:  "Ευχαριστούμε! Θα ειδοποιηθείτε όταν αυτό το προϊόν είναι διαθέσιμο.",
      error:    "Παρουσιάστηκε σφάλμα. Παρακαλώ δοκιμάστε ξανά.",
      invalid:  "Μη έγκυρη διεύθυνση email.",
    },
    hu: {
      notify:   "Értesítsen Amikor Elérhető",
      title:    "Értesítsen amikor elérhető",
      desc:     "Adja meg e-mail címét, hogy értesítést kapjon, amikor ez a termék újra elérhető lesz.",
      submit:   "Értesítsen",
      success:  "Köszönjük! Értesítést kap, amikor ez a termék elérhető lesz.",
      error:    "Hiba történt. Kérjük, próbálja újra.",
      invalid:  "Érvénytelen e-mail cím.",
    },
    sk: {
      notify:   "Upozorniť Ma Keď Je Dostupné",
      title:    "Upozorniť ma keď je dostupné",
      desc:     "Zadajte svoju e-mailovú adresu, aby ste boli upozornení, keď bude tento produkt opäť skladom.",
      submit:   "Upozorniť ma",
      success:  "Ďakujeme! Budete upozornení, keď bude tento produkt dostupný.",
      error:    "Vyskytla sa chyba. Skúste to prosím znova.",
      invalid:  "Neplatná e-mailová adresa.",
    },
    lt: {
      notify:   "Pranešti Man Kai Bus Prieinama",
      title:    "Pranešti man kai bus prieinama",
      desc:     "Įveskite savo el. pašto adresą, kad gautumėte pranešimą, kai šis produktas vėl bus sandėlyje.",
      submit:   "Pranešti man",
      success:  "Ačiū! Būsite informuoti, kai šis produktas bus prieinamas.",
      error:    "Įvyko klaida. Bandykite dar kartą.",
      invalid:  "Neteisingas el. pašto adresas.",
    },
    et: {
      notify:   "Teavita Mind Saadavusest",
      title:    "Teavita mind saadavusest",
      desc:     "Sisestage oma e-posti aadress, et saada teavitus, kui see toode on uuesti laos.",
      submit:   "Teavita mind",
      success:  "Täname! Teid teavitatakse, kui see toode on saadaval.",
      error:    "Ilmnes viga. Palun proovige uuesti.",
      invalid:  "Vigane e-posti aadress.",
    },
    ga: {
      notify:   "Cuir In Iúl Dom Nuair Atá Ar Fáil",
      title:    "Cuir in iúl dom nuair atá ar fáil",
      desc:     "Cuir isteach do sheoladh ríomhphoist le bheith ar an eolas nuair a bheidh an táirge seo ar fáil arís.",
      submit:   "Cuir in iúl dom",
      success:  "Go raibh maith agat! Cuirfear in iúl duit nuair a bheidh an táirge seo ar fáil.",
      error:    "Tharla earráid. Déan iarracht arís le do thoil.",
      invalid:  "Seoladh ríomhphoist neamhbhailí.",
    },
    lb: {
      notify:   "Matdeelen Wann Verfügbar",
      title:    "Matdeelen wann verfügbar",
      desc:     "Gitt är E-Mail-Adress an fir informéiert ze ginn wann dëst Produkt erëm verfügbar ass.",
      submit:   "Matdeelen",
      success:  "Merci! Dir gitt informéiert wann dëst Produkt verfügbar ass.",
      error:    "E Feeler ass opgetrueden. Probéiert w.e.g. nach eng Kéier.",
      invalid:  "Ongülteg E-Mail-Adress.",
    },
  };

  var _locale    = (window.Shopify && window.Shopify.locale && window.Shopify.locale.split('-')[0]) || 'fr';
  var _t         = TRANSLATIONS[_locale] || TRANSLATIONS['fr'];
  var _urlPrefix = (function () {
    var m = window.location.pathname.match(/^(\/[a-z]{2}(-[a-z]{2})?)\//i);
    return m ? m[1] : '';
  })();

  var TEXT_NOTIFY  = _t.notify;
  var TEXT_TITLE   = _t.title;
  var TEXT_DESC    = _t.desc;
  var TEXT_SUBMIT  = _t.submit;
  var TEXT_SUCCESS = _t.success;
  var TEXT_ERROR   = _t.error;

  // ─── Variante "à venir" (produits en pré-commande) ────────────────────────
  // Sur les fiches produit utilisant le template `product.a-venir`, seul le
  // libellé change (coche verte) — le bouton garde le style ATC par défaut.
  var PREORDER_TEMPLATE_SUFFIX = 'a-venir';
  var PREORDER_NOTIFY_ICON     = '✅ ';
  var PREORDER_NOTIFY_TEXT     = {
    fr: "M'avertir dès que disponible",
    en: "Notify Me As Soon As Available",
    es: "Avisarme En Cuanto Esté Disponible",
    de: "Benachrichtige Mich, Sobald Verfügbar",
    it: "Avvisami Non Appena Disponibile",
    nl: "Meld Me Zodra Beschikbaar",
    pt: "Avisar-me Assim Que Disponível",
    sv: "Meddela Mig Så Snart Den Är Tillgänglig",
    da: "Giv Mig Besked Så Snart Den Er Tilgængelig",
    pl: "Powiadom Mnie, Jak Tylko Będzie Dostępny",
    ro: "Anunțați-mă De Îndată Ce Este Disponibil",
    el: "Ειδοποίησέ Με Μόλις Είναι Διαθέσιμο",
    hu: "Értesítsen, Amint Elérhető",
    sk: "Upozorniť Ma Hneď Ako Bude Dostupné",
    lt: "Pranešti Man, Kai Tik Bus Prieinama",
    et: "Teavita Mind Kohe, Kui Saadaval",
    ga: "Cuir In Iúl Dom A Luaithe Atá Ar Fáil",
    lb: "Matdeelen Sou Bal Verfügbar",
  };

  function setNotifyText(el, isPreorder) {
    el.textContent = isPreorder
      ? PREORDER_NOTIFY_ICON + (PREORDER_NOTIFY_TEXT[_locale] || TEXT_NOTIFY)
      : TEXT_NOTIFY;
  }

  // ─── État ─────────────────────────────────────────────────────────────────
  var productData      = null;
  var oosEnabled       = false;  // true si alertes activées pour ce produit
  var oosChecked       = false;  // true si on a déjà vérifié
  var _oosClickHandler = null;   // handler attaché au bouton ATC (fiche produit)

  // Cache pour le catalogue (évite doublons de requêtes)
  var _oosCatalogCache = {}; // { [productId]: boolean }
  var _oosCatalogCbs   = {}; // { [productId]: [callbacks] } — en attente

  // ─── Démarrage ────────────────────────────────────────────────────────────
  function boot() {
    if (!window.location.pathname.includes('/products/')) return;

    // Lire les données produit depuis l'attribut embarqué (évite les 404 sur les handles traduits)
    // Restriction à .product-buy-buttons pour ne pas capter les cartes de produits recommandés
    var jsonEl = document.querySelector('.product-buy-buttons [data-product-json]');
    if (jsonEl) {
      try {
        productData = JSON.parse(jsonEl.dataset.productJson);
        injectStyles();
        var variantId = getCurrentVariantId();
        if (variantId) checkAndUpdate(variantId);
      } catch (e) {
        console.warn('[Amalgamous OOS] erreur parsing data-product-json:', e);
      }
    } else {
      // Fallback : fetch par handle (locale par défaut uniquement)
      var handleEl = document.querySelector('[data-product-handle]');
      var handle = handleEl
        ? handleEl.dataset.productHandle
        : window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          productData = data;
          injectStyles();
          var variantId = getCurrentVariantId();
          if (variantId) checkAndUpdate(variantId);
        })
        .catch(function (e) { console.warn('[Amalgamous OOS]', e); });
    }

    // Écouter les changements de variante
    window.addEventListener('variantChange.shopiweb.product', function (e) {
      checkAndUpdate(e.detail.id);
    });
  }

  function getCurrentVariantId() {
    var form = document.querySelector(SEL_FORM);
    var inp  = form && form.querySelector('[name="id"]');
    return inp ? parseInt(inp.value, 10) : null;
  }

  function isVariantOutOfStock(variantId) {
    if (!productData) return false;
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      if (v.id === variantId) return !v.available;
    }
    return false;
  }

  // ─── Vérifier alertes via métafield (fiche produit) ──────────────────────
  function checkOosEnabled(numericProductId, callback) {
    if (oosChecked) { callback(oosEnabled); return; }
    var buyButtons = document.querySelector(SEL_BUY_BUTTONS);
    oosEnabled = buyButtons ? buyButtons.dataset.bisEnabled === 'true' : false;
    oosChecked = true;
    callback(oosEnabled);
  }

  // ─── Vérifier alertes via métafield (catalogue) ───────────────────────────
  function checkOosEnabledForProduct(pid, callback) {
    if (pid in _oosCatalogCache) { callback(_oosCatalogCache[pid]); return; }
    var card = document.querySelector('li.product-item[data-product-id="' + pid + '"]');
    _oosCatalogCache[pid] = card ? card.dataset.bisEnabled === 'true' : false;
    callback(_oosCatalogCache[pid]);
  }

  // ─── Logique principale ───────────────────────────────────────────────────
  function checkAndUpdate(variantId) {
    var outOfStock = isVariantOutOfStock(variantId);

    if (!outOfStock) {
      removeWidget();
      return;
    }

    // Variante en rupture : vérifier alertes
    var numericProductId = String(productData.id);
    checkOosEnabled(numericProductId, function (enabled) {
      if (!enabled) {
        removeWidget();
        return;
      }
      renderWidget(variantId);
    });
  }

  // ─── Widget : transforme le bouton ATC en bouton alerte ───────────────────
  function renderWidget(variantId) {
    // Nettoyer l'état précédent
    removeWidget();

    var atcBtn = document.querySelector(SEL_BTN);
    if (!atcBtn) return;

    // Sauvegarder le texte original
    var textEl = atcBtn.querySelector(SEL_BTN_TEXT);
    atcBtn.dataset.amalgamousOrigText = textEl ? textEl.textContent : atcBtn.textContent;
    atcBtn.dataset.amalgamousOos = '1';

    var buyButtons = document.querySelector(SEL_BUY_BUTTONS);
    var isPreorder = buyButtons ? buyButtons.dataset.templateSuffix === PREORDER_TEMPLATE_SUFFIX : false;

    // Remplacer le texte
    if (textEl) setNotifyText(textEl, isPreorder);
    else setNotifyText(atcBtn, isPreorder);

    // Appliquer le style OOS (override du thème) — sauf en pré-commande, où le
    // bouton garde son style ATC d'origine (couleur, forme, etc.)
    if (!isPreorder) atcBtn.classList.add('amalgamous-oos-active');

    // S'assurer que le bouton est cliquable (le thème peut le désactiver pour OOS)
    atcBtn.disabled = false;

    // Intercepter le clic pour ouvrir le popup au lieu d'ajouter au panier
    _oosClickHandler = function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showPopup(variantId, String(productData.id));
    };
    atcBtn.addEventListener('click', _oosClickHandler, true);
  }

  function removeWidget() {
    removePopup();

    var atcBtn = document.querySelector(SEL_BTN);
    if (!atcBtn || !atcBtn.dataset.amalgamousOos) return;

    // Retirer le handler
    if (_oosClickHandler) {
      atcBtn.removeEventListener('click', _oosClickHandler, true);
      _oosClickHandler = null;
    }

    // Ne pas restaurer le texte : le thème a déjà mis à jour le libellé du bouton
    // AVANT de dispatcher variantChange. Restaurer ici écraserait le bon texte ("Pré-Commander").
    atcBtn.classList.remove('amalgamous-oos-active');
    atcBtn.disabled = false;
    delete atcBtn.dataset.amalgamousOos;
    delete atcBtn.dataset.amalgamousOrigText;
  }

  // ─── Popup ────────────────────────────────────────────────────────────────
  var POPUP_ID = 'amalgamous-oos-popup';

  function removePopup() {
    var p = document.getElementById(POPUP_ID);
    if (p) p.parentNode.removeChild(p);
  }

  function showPopup(variantId, numericProductId) {
    removePopup();

    var overlay = document.createElement('div');
    overlay.id = POPUP_ID;
    overlay.className = 'amalgamous-oos-overlay';

    var modal = document.createElement('div');
    modal.className = 'amalgamous-oos-modal';

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'amalgamous-oos-close';
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', removePopup);

    // Title
    var title = document.createElement('h3');
    title.className = 'amalgamous-oos-title';
    title.textContent = TEXT_TITLE;

    // Description
    var desc = document.createElement('p');
    desc.className = 'amalgamous-oos-desc';
    desc.textContent = TEXT_DESC;

    // Email input
    var input = document.createElement('input');
    input.type = 'email';
    input.placeholder = 'votre@email.com';
    input.className = 'amalgamous-oos-input';
    input.autocomplete = 'email';

    // Submit button
    var submitBtn = document.createElement('button');
    submitBtn.type = 'button';
    submitBtn.className = 'amalgamous-oos-submit';
    submitBtn.textContent = TEXT_SUBMIT;

    // Message zone
    var msgEl = document.createElement('p');
    msgEl.className = 'amalgamous-oos-msg';
    msgEl.style.display = 'none';

    submitBtn.addEventListener('click', function () {
      var email = input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msgEl.style.display = '';
        msgEl.style.color = '#c00';
        msgEl.textContent = _t.invalid;
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      fetch('/apps/amalgamous/bis/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          productId: numericProductId,
          variantId: String(variantId),
          locale: (window.Shopify && window.Shopify.locale) || 'fr',
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.ok) {
            msgEl.style.display = '';
            msgEl.style.color = '#166534';
            msgEl.textContent = TEXT_SUCCESS;
            input.style.display = 'none';
            submitBtn.style.display = 'none';
          } else {
            msgEl.style.display = '';
            msgEl.style.color = '#c00';
            msgEl.textContent = d.error || TEXT_ERROR;
            submitBtn.disabled = false;
            submitBtn.textContent = TEXT_SUBMIT;
          }
        })
        .catch(function () {
          msgEl.style.display = '';
          msgEl.style.color = '#c00';
          msgEl.textContent = TEXT_ERROR;
          submitBtn.disabled = false;
          submitBtn.textContent = TEXT_SUBMIT;
        });
    });

    // Also submit on Enter
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submitBtn.click();
    });

    modal.appendChild(closeBtn);
    modal.appendChild(title);
    modal.appendChild(desc);
    modal.appendChild(input);
    modal.appendChild(submitBtn);
    modal.appendChild(msgEl);
    overlay.appendChild(modal);

    // Close on overlay click
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) removePopup();
    });

    document.body.appendChild(overlay);
    setTimeout(function () { input.focus(); }, 50);
  }

  // ─── Dropdown de sélection de variante (catalogue multi-variante) ──────────
  var OOS_VAR_DROPDOWN = 'amalgamous-oos-var-dropdown';

  function showVariantDropdown(atcBtn, card, variants, pid) {
    // Toggle : si déjà ouvert, fermer
    var existing = card.querySelector('.' + OOS_VAR_DROPDOWN);
    if (existing) { existing.parentNode.removeChild(existing); return; }

    var dropdown = document.createElement('ul');
    dropdown.className = OOS_VAR_DROPDOWN;

    for (var i = 0; i < variants.length; i++) {
      (function (variant) {
        var li  = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'amalgamous-oos-var-option';
        btn.textContent = variant.title;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (dropdown.parentNode) dropdown.parentNode.removeChild(dropdown);
          showPopup(variant.id, pid);
        });
        li.appendChild(btn);
        dropdown.appendChild(li);
      })(variants[i]);
    }

    // Positionné au-dessus du bouton
    var container = atcBtn.closest('.product-buy-buttons') || atcBtn.parentNode;
    container.style.position = 'relative';
    container.appendChild(dropdown);

    // Fermer si clic en dehors
    var closeDropdown = function (e) {
      if (!dropdown.contains(e.target) && e.target !== atcBtn) {
        if (dropdown.parentNode) dropdown.parentNode.removeChild(dropdown);
        document.removeEventListener('click', closeDropdown);
      }
    };
    setTimeout(function () { document.addEventListener('click', closeDropdown); }, 0);
  }

  // ─── Catalogue : patch d'une carte produit ────────────────────────────────
  function patchCatalogCard(card, product) {
    if (card.dataset.amalgamousOosPatched) return;

    var variants = product.variants || [];
    if (!variants.length) return;

    // Le bouton alerte ne s'affiche que si TOUTES les variantes sont en rupture
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return;
    }

    var pid = String(product.id);
    checkOosEnabledForProduct(pid, function (enabled) {
      if (!enabled) return;

      var atcBtn = card.querySelector(SEL_BTN);
      if (!atcBtn) return;

      card.dataset.amalgamousOosPatched = '1';
      atcBtn.dataset.amalgamousOos = '1';

      var isPreorder = card.dataset.templateSuffix === PREORDER_TEMPLATE_SUFFIX;

      var textEl = atcBtn.querySelector(SEL_BTN_TEXT);
      atcBtn.dataset.amalgamousOrigText = textEl ? textEl.textContent : atcBtn.textContent;
      if (textEl) setNotifyText(textEl, isPreorder);
      else setNotifyText(atcBtn, isPreorder);

      if (!isPreorder) atcBtn.classList.add('amalgamous-oos-active');
      atcBtn.disabled = false;

      // Supprimer le data-bs-toggle ajouté par preorder-widget pour éviter
      // que le dropdown Bootstrap se déclenche en même temps que notre popup
      atcBtn.removeAttribute('data-bs-toggle');
      atcBtn.classList.remove('dropdown-toggle');

      var handler = function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (variants.length > 1) {
          showVariantDropdown(atcBtn, card, variants, pid);
        } else {
          showPopup(variants[0].id, pid);
        }
      };
      atcBtn.addEventListener('click', handler, true);
    });
  }

  // ─── Catalogue : démarrage ────────────────────────────────────────────────
  function bootCatalog() {
    if (window.location.pathname.includes('/products/')) return;
    injectStyles();

    function processCards() {
      document.querySelectorAll('li.product-item').forEach(function (card) {
        if (card.dataset.amalgamousOosPatched) return;
        if (card.closest('#offcanvas-wishlist')) return;
        var pid = card.dataset.productId;
        var variantsJson = card.dataset.catalogVariants;
        if (!pid || !variantsJson) return;
        try {
          var variants = JSON.parse(variantsJson);
          patchCatalogCard(card, { id: parseInt(pid, 10), variants: variants });
        } catch (e) {}
      });
    }

    // Scan initial
    processCards();

    // Observer pour les produits chargés dynamiquement (infinite scroll / load more)
    var debounce = null;
    new MutationObserver(function (mutations) {
      var hasNewProducts = mutations.some(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (node.matches('li.product-item') || node.querySelector('li.product-item')) return true;
        }
        return false;
      });
      if (!hasNewProducts) return;
      clearTimeout(debounce);
      debounce = setTimeout(processCards, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ─── Styles ────────────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById(STYLES_ID)) return;
    var style = document.createElement('style');
    style.id = STYLES_ID;
    style.textContent = [
      '.amalgamous-oos-active {',
      '  background: #000 !important;',
      '  border-color: #F6AB13 !important;',
      '  border-radius: 1px !important',
      '  color: #fff !important;',
      '}',
      '.amalgamous-oos-active:hover { opacity: 0.85 !important; }',

      '.amalgamous-oos-overlay {',
      '  position: fixed;',
      '  inset: 0;',
      '  background: rgba(0,0,0,0.5);',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  z-index: 9999;',
      '}',

      '.amalgamous-oos-modal {',
      '  background: white;',
      '  border-radius: 12px;',
      '  padding: 28px 28px 24px;',
      '  max-width: 420px;',
      '  width: 90%;',
      '  position: relative;',
      '  box-shadow: 0 8px 32px rgba(0,0,0,0.18);',
      '}',

      '.amalgamous-oos-close {',
      '  position: absolute;',
      '  top: 14px;',
      '  right: 16px;',
      '  background: none;',
      '  border: none;',
      '  font-size: 22px;',
      '  cursor: pointer;',
      '  color: #aaa;',
      '  line-height: 1;',
      '  padding: 0;',
      '}',
      '.amalgamous-oos-close:hover { color: #555; }',

      '.amalgamous-oos-title {',
      '  margin: 0 0 8px;',
      '  font-size: 18px;',
      '  font-weight: 800;',
      '  line-height: 1.2;',
      '}',

      '.amalgamous-oos-desc {',
      '  margin: 0 0 16px;',
      '  font-size: 14px;',
      '  color: #555;',
      '  line-height: 1.5;',
      '}',

      '.amalgamous-oos-input {',
      '  display: block;',
      '  width: 100%;',
      '  padding: 11px 14px;',
      '  border: 1px solid #d1d5db;',
      '  border-radius: 8px;',
      '  font-size: 15px;',
      '  margin-bottom: 12px;',
      '  box-sizing: border-box;',
      '  outline: none;',
      '}',
      '.amalgamous-oos-input:focus { border-color: #1a2e4a; box-shadow: 0 0 0 3px rgba(26,46,74,0.15); }',

      '.amalgamous-oos-submit {',
      '  display: block;',
      '  width: 100%;',
      '  padding: 12px 20px;',
      '  background: #1a2e4a;',
      '  color: white;',
      '  border: none;',
      '  border-radius: 8px;',
      '  font-size: 15px;',
      '  font-weight: 700;',
      '  cursor: pointer;',
      '  letter-spacing: 0.03em;',
      '}',
      '.amalgamous-oos-submit:hover:not(:disabled) { opacity: 0.9; }',
      '.amalgamous-oos-submit:disabled { opacity: 0.6; cursor: default; }',

      '.amalgamous-oos-msg {',
      '  margin: 10px 0 0;',
      '  font-size: 13px;',
      '  line-height: 1.4;',
      '}',

      '.amalgamous-oos-var-dropdown {',
      '  position: absolute;',
      '  bottom: 100%;',
      '  left: 0;',
      '  right: 0;',
      '  z-index: 300;',
      '  background: #fff;',
      '  border: 1px solid var(--bs-border-color, #d1d5db);',
      '  border-radius: 6px;',
      '  box-shadow: 0 4px 12px rgba(0,0,0,.15);',
      '  list-style: none;',
      '  margin: 0 0 4px;',
      '  padding: 4px 0;',
      '  overflow: hidden;',
      '}',
      '.amalgamous-oos-var-option {',
      '  display: block;',
      '  width: 100%;',
      '  padding: 10px 14px;',
      '  font-size: 14px;',
      '  border: none;',
      '  background: transparent;',
      '  cursor: pointer;',
      '  text-align: left;',
      '  color: var(--bs-body-color, #111);',
      '}',
      '.amalgamous-oos-var-option:hover { background: var(--bs-light, #f8f9fa); }',
    ].join('\n');
    document.head.appendChild(style);
  }

  // ─── Search drawer : cartes produit dynamiques ───────────────────────────
  function bootSearchDrawer() {
    injectStyles();

    var container = document.getElementById('search-predictive');
    if (!container) return;

    function processCards() {
      container.querySelectorAll('li.product-item').forEach(function (card) {
        if (card.dataset.amalgamousOosPatched) return;
        var pid = card.dataset.productId;
        var variantsJson = card.dataset.catalogVariants;
        if (!pid || !variantsJson) return;
        try {
          var variants = JSON.parse(variantsJson);
          patchCatalogCard(card, { id: parseInt(pid, 10), variants: variants });
        } catch (e) {}
      });
    }

    var debounce = null;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(processCards, 150);
    }).observe(container, { childList: true, subtree: true });
  }

  // ─── Lancement ─────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); bootCatalog(); bootSearchDrawer(); });
  } else {
    boot();
    bootCatalog();
    bootSearchDrawer();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector(SEL_FORM)) {
      productData = null;
      oosChecked  = false;
      oosEnabled  = false;
      boot();
    }
  });

})();
